import { Container, Group, useMantineColorScheme } from '@mantine/core';
import { Prism } from '@mantine/prism';
import styled from 'styled-components';

import { Button, colors, Text } from '../../design-system';
import { Close } from '../../design-system/icons/actions/Close';

const ExecutionDetailShowRawWrapper = styled(Container)`
  display: flex;
  flex-flow: column;
  margin: 0;
  padding: 0;
  vertical-align: middle;
`;

const DetailTitle = styled(Text)`
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  padding-bottom: 20px;
`;

const ActionButton = styled(Button)<{ theme: string }>`
  background-color: transparent;
  background-image: none;
  border: 1px solid ${({ theme }) => (theme.colorScheme === 'dark' ? colors.B40 : colors.B80)};
  border-radius: 7px;
  box-shadow: none;
  color: ${({ theme }) => (theme.colorScheme === 'dark' ? colors.white : colors.B40)};
  font-size: 12px;
  font-weight: 700;
  height: 30px;
  padding: 0;
  width: 95px;
`;

const CloseButton = styled(Button)<{ theme: string }>`
  background-color: transparent;
  background-image: none;
  border-radius: 30px;
  box-shadow: none;
  color: ${({ theme }) => (theme.colorScheme === 'dark' ? colors.white : colors.B40)};
  display: flex;
  height: 15px;
  margin: 0;
  padding: 0;
  position: relative;
  top: -10px;
`;

export const ExecutionDetailShowRaw = ({ onShowExecutionDetail, onHideExecutionDetail, showTriggerSnippet }) => {
  const theme = useMantineColorScheme();

  const action = showTriggerSnippet ? onShowExecutionDetail : onHideExecutionDetail;
  const label = showTriggerSnippet ? 'Show detail' : 'Close detail';

  const onClick = () => {
    action();
  };

  return (
    <ActionButton theme={theme} onClick={onClick}>
      {label}
    </ActionButton>
  );
};

export const ExecutionDetailRawSnippet = ({ raw, onClose }) => {
  const theme = useMantineColorScheme();

  const prismStyles = {
    code: {
      fontWeight: 400,
      color: `${colors.B60} !important`,
      backgroundColor: 'transparent !important',
      border: ` 1px solid ${theme.colorScheme === 'dark' ? colors.B70 : colors.B30}`,
      borderRadius: '7px',
    },
  };

  return (
    <ExecutionDetailShowRawWrapper>
      <Group position="apart">
        <DetailTitle>Detail</DetailTitle>
        <CloseButton onClick={onClose}>
          <Close />
        </CloseButton>
      </Group>
      <Prism
        colorScheme={theme.colorScheme}
        mt={5}
        styles={prismStyles}
        data-test-id="execution-detail-raw-snippet"
        language="json"
      >
        {JSON.stringify(JSON.parse(raw), null, 2)}
      </Prism>
    </ExecutionDetailShowRawWrapper>
  );
};
